<template>
	<div class="ol-sm-12 col-lg-2" :class="{'close-filter': openFilters !== 'narrow'}">
		<div class="filter__wrapper" :class="{open: 'country' === showList, close: 'country' !== showList}">
			<input type="text"
				   :placeholder="$t('filters.country')"
				   class="filter"
				   :class="{open: 'country' === showList, close: 'country' !== showList}"
				   @click="updateShowList('country')"
				   @input="showList = 'country'"
				   v-model="searchByCountry"
			>
			<ul v-show="'country' === showList"
				class="filter__list"
			>

				<li v-for="item in countryList"
					class="filter__list-item"
				>
					<label class="filter__label">
						{{item.name}}
						<input class="filter__input"
							   type="checkbox"
							   :value="item"
							   :checked="$store.getters.isCountryActive(item)"
							   @change="changeFilters($event, item)"
						>
						<span class="filter__checkbox"></span>
					</label>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'

	export default {
		props: ['openFilters'],
		data () {
			return {
				showList: '',
				searchByCountry: ''
			}
		},
		methods: {
			...mapActions(['fetchJudges']),
			...mapActions(['fetchJudgeCountries']),
			changeFilters (e, item) {
				if (e.target.checked) {
					this.$store.commit('addCountry', item)
					this.fetchJudges()
				} else {
					this.$store.commit('removeCountry', item)
					this.fetchJudges()
				}
			},
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			}
		},
		computed: {
			countryList () {
				const inputTest = person => {
					const regExp = new RegExp('^' + this.searchByCountry, 'i')
					return regExp.test(person.name)
				}
				return this.$store.state.judges.countries.filter(inputTest)
			}
		},
		created () {
			window.addEventListener('click', this.closeFlitersLists)
			this.fetchJudgeCountries()
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";
	@import "../../../styles/filters.scss";
</style>



// WEBPACK FOOTER //
// src/components/JudgesList/Filters/CountryFilterComponent.vue